import { InputHTMLAttributes, forwardRef } from "react";
import { cn } from "@/lib/cn";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { label, hint, error, id, className, ...rest }, ref
) {
  const describedBy = error ? `${id}-err` : hint ? `${id}-hint` : undefined;
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={id} className="text-xs font-medium text-text-muted">
          {label}
        </label>
      )}
      <input
        id={id}
        ref={ref}
        aria-describedby={describedBy}
        aria-invalid={!!error || undefined}
        className={cn(
          "h-9 px-3 text-sm bg-bg-elevated border rounded",
          "border-border focus:outline-none",
          error ? "border-danger" : "",
          className,
        )}
        {...rest}
      />
      {error && <span id={`${id}-err`} className="text-xs text-danger">{error}</span>}
      {!error && hint && <span id={`${id}-hint`} className="text-xs text-text-subtle">{hint}</span>}
    </div>
  );
});
